import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useReducer, useContext, useMemo } from 'react';
import { createAction, handleActions } from 'redux-actions';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
const onMouseEnter = createAction('mouseenter', (isMobile)=>({
        isMobile
    }));
const onMouseLeave = createAction('mouseleave', ()=>({}));
const onReferenceClick = createAction('refclick', (hasPopover)=>({
        hasPopover
    }));
const onClose = createAction('hide', ()=>({}));
const reducer = handleActions({
    [onMouseEnter.toString()]: (state, { payload: { isMobile } })=>state.showTooltip || isMobile ? state : {
            showTooltip: 'tooltip'
        },
    [onMouseLeave.toString()]: (state)=>state.showTooltip === 'tooltip' ? {
            showTooltip: false
        } : state,
    [onReferenceClick.toString()]: (state, { payload: { hasPopover } })=>{
        if (!hasPopover || state.showTooltip === 'popover') {
            return {
                showTooltip: false
            };
        }
        return {
            showTooltip: 'popover'
        };
    },
    [onClose.toString()]: (state)=>state.showTooltip ? _object_spread_props(_object_spread({}, state), {
            showTooltip: false
        }) : state
}, {
    showTooltip: false
});
export function usePopoverOrTooltip(hasPopover, hasTooltip, openBiData, closeBiData) {
    const isMobile = useContext(MobileContext);
    const [state, dispatch] = useReducer(reducer, {
        showTooltip: false
    });
    const logBiEvent = useBiLogger();
    const biData = useDeepEqualMemo((state === null || state === void 0 ? void 0 : state.showTooltip) === 'popover' ? closeBiData : openBiData);
    return useMemo(()=>({
            showTooltip: state && state.showTooltip || false,
            onMouseEnter: hasTooltip ? ()=>dispatch(onMouseEnter(isMobile)) : undefined,
            onMouseLeave: hasTooltip ? ()=>dispatch(onMouseLeave()) : undefined,
            onReferenceClick: ()=>{
                biData && logBiEvent(biData);
                dispatch(onReferenceClick(hasPopover));
            },
            onClose: ()=>dispatch(onClose())
        }), [
        biData,
        hasPopover,
        hasTooltip,
        isMobile,
        logBiEvent,
        state
    ]);
}
